
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import singleServiceTime from '@xt/client/experimental/server-time'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ShowCommoditySwiperConfig } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class SectionItemThird extends Mixins(MixinsHomeClick) {
  @Prop() config: ShowCommoditySwiperConfig

  getIsClickDisable() {
    const { signUpStartTime } = this.config

    return singleServiceTime.serviceDate.isBefore(signUpStartTime)
  }

  get btnText() {
    const now = singleServiceTime.serviceDate

    const { signUpStartTime, startTime, signUpEndTime, endTime, voteStartTime, voteEndTime } = this.config

    const signUpStartTimeMoment = this.moment(signUpStartTime)
    const signUpEndTimeMoment = this.moment(signUpEndTime)
    const voteStartTimeMoment = this.moment(voteStartTime)
    const voteEndTimeMoment = this.moment(voteEndTime)
    const endTimeMoment = this.moment(endTime)
    const startTimeMoment = this.moment(startTime)

    if (now.isBefore(signUpStartTimeMoment)) {
      return '报名未开始'
    } else if (now.isAfter(signUpStartTimeMoment) && now.isBefore(signUpEndTimeMoment)) {
      return '正在报名'
    } else if (now.isAfter(startTimeMoment) && now.isBefore(endTimeMoment)) {
      return '备展中'
    } else if (now.isAfter(endTimeMoment) && now.isBefore(voteStartTimeMoment)) {
      return '备展结束'
    } else if (now.isAfter(voteStartTimeMoment) && now.isBefore(voteEndTimeMoment)) {
      return '投票中'
    } else {
      return '观展'
    }
  }

  handleOpen() {
    if (this.config.event) {
      this.onClickEvent(this.config.event)
      return
    }

    if (this.getIsClickDisable()) return

    window.open(`/commodity/${this.config.productId}`)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
